"use client";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="ru">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          fontFamily: "system-ui, sans-serif",
          background: "#f7f8fa",
          color: "#1c2430",
        }}
      >
        <main style={{ maxWidth: 420, padding: 24 }}>
          <h1 style={{ fontSize: 24, marginBottom: 8 }}>Сервис временно недоступен</h1>
          <p style={{ color: "#5c6b7e" }}>Обновите страницу через несколько секунд.</p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              marginTop: 16,
              minHeight: 44,
              padding: "0 16px",
              border: 0,
              borderRadius: 8,
              background: "#0f6e68",
              color: "#fff",
            }}
          >
            Попробовать снова
          </button>
        </main>
      </body>
    </html>
  );
}
